<template>
    <div class="foodmash-card foodmash-default foodmash-deck-empty">
        <div class="foodmash-frame">
            <span>{{ messageToShow }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FoodmashDeckEmpty',
    props: {
        messageToShow: String
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/FoodmashDeckEmpty.vue